import { render, staticRenderFns } from "./EducationalGroupStudentInfo.vue?vue&type=template&id=437c9420&"
import script from "./EducationalGroupStudentInfo.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupStudentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports